import * as Yup from 'yup';
import {emailSchema, phoneSchema} from '@/utils/validation';
import {IOrganizationSponsor} from '@/utils/types';
import {CATEGORY, EVENT_ID, ID} from '@/utils/constants';
import {TablesMeals} from '@/utils/enums';

export type EventSponsor = Omit<IOrganizationSponsor, typeof ID | typeof CATEGORY | typeof EVENT_ID> & {
	logo: File[];
	uniqueId: string;
};

export type ProfileValues = {
	firstName: string;
	lastName: string;
	address: string;
	state: string;
	city: string;
	meals: TablesMeals[];
	zip: string;
	email: string;
	phoneNumber: string;
};

export const defaultInitialValues: ProfileValues = {
	firstName: '',
	lastName: '',
	address: '',
	state: '',
	city: '',
	meals: [],
	zip: '',
	email: '',
	phoneNumber: '',
};

export const validationSchema = () => {
	return Yup.object().shape({
		firstName: Yup.string().required('First name  is required').trim(),
		lastName: Yup.string().required('Last name  is required').trim(),
		email: emailSchema,
		phoneNumber: phoneSchema,
	});
};

export enum TABLES_MEALS {
	VEGETARIAN = 'Vegetarian',
	VEGAN = 'Vegan',
	GLUTEN_FREE = 'GlutenFree',
	KOSHER = 'Kosher',
	DAIRY_FREE = 'DairyFree',
	NUT_ALLERGY = 'NutAllergy',
}

export interface IUser {
	added: string;
	edited: string;
	email: string;
	firstName: string;
	id: number;
	lastName: string;
	meals: TABLES_MEALS[];
	phoneNumber: string;
	address?: string;
	city?: string;
	state?: string;
	zip?: string;
}

export interface IProfileGeneralProps {
	user: IUser;
}

export function normalizeMeals(input: unknown): TABLES_MEALS[] {
	return Array.isArray(input) ? input : [];
}
